
import { Tab } from './Tab'


import type { ChatTab } from '../../hooks/useTabManager'

export interface TabBarProps {
    tabs: ChatTab[]
    activeTabId: string
    agentAvatars?: Record<string, string | null>
    onTabClick: (tabId: string) => void
    onTabClose: (tabId: string) => void
    onTabReorder?: (tabId: string, newPosition: number) => void
    onAddTab?: () => void
    newTabButtonRef?: React.RefObject<HTMLButtonElement | null>
}

export function TabBar({
    tabs,
    activeTabId,
    agentAvatars = {},
    onTabClick,
    onTabClose,
    onAddTab,
    newTabButtonRef
}: TabBarProps) {
    return (
        <div className="flex items-center gap-1 border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-black overflow-x-auto">
            {tabs.map((tab) => (
                <Tab
                    key={tab.id}
                    id={tab.id}
                    name={tab.name}
                    isActive={tab.id === activeTabId}
                    // Force unpin everywhere so all tabs can be closed
                    isPinned={false}
                    unreadCount={tab.unread_count}
                    agentId={tab.agent_id}
                    avatarUrl={tab.agent_id ? agentAvatars[tab.agent_id] : null}
                    onClick={() => onTabClick(tab.id)}
                    onClose={() => onTabClose(tab.id)}
                />
            ))}

            {/* New tab button */}
            <button
                ref={newTabButtonRef}
                onClick={onAddTab}
                className="flex items-center justify-center p-2 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                aria-label="New tab"
                title="Search for agent to open new tab"
            >
                <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
            </button>
        </div>
    )
}
